<!-- 位度系统对接 设备信息 -->
<template>
  <dev>
    <avue-crud
      ref="crud"
      v-model="form"
      :option="option"
      :table-loading="loading"
      :data="data"
      :page.sync="page"
      :search.sync="query"
      :defaults.sync="defaults"
      @row-save="rowSave"
      @row-update="rowUpdate"
      @row-del="rowDel"
      @search-change="searchChange"
      @search-reset="searchReset"
      @refresh-change="refreshChange" :beforeOpen="beforeOpen"
      @current-change="currentChange"
      @size-change="sizeChange"
      @on-load="onLoad"
    >
      <template slot="menuLeft">
        <el-button type="primary" icon="el-icon-download" size="small" :loading="exportLoading" @click="handleExport">
          导出
        </el-button>
      </template>
    </avue-crud>
  </dev>
</template>

<script>
import crudMixins from "@/mixins/crud-mixins";
import {getList, add, update, remove, getDetail, exportExcel} from "./api";
import {downloadXls} from "@/util/util";

export default {
  mixins: [crudMixins],
  data() {
    return {
      apiConfig: {getList, add, update, remove, getDetail},
      exportLoading: false,
      infoCardData: [], // 卡片数据
      option: {
        ...this.$store.state.publicOption,
        column: [
          {
            label: '标签ID',
            prop: 'tagId',
            search: true, // 查询是否显示
            rules: [
              {required: true, message: '请输入标签ID', trigger: 'change'}
            ],
          },
          {
            label: '设备名称',
            prop: 'deviceName',
            type: "input",
            addDisplay: true,
            editDisplay: true,
            viewDisplay: true,
            overHidden: true,
            search: true, // 查询是否显示
            rules: [
              {required: true, message: '请输入设备名称', trigger: 'change'}
            ],
          },
          {
            label: "设备类型",
            prop: "deviceType",
            type: 'select',
            overHidden: true,
            search: false,
            dicUrl: "/api/blade-system/dict-biz/dictionary?code=weidu_device_type",
            dataType: 'string',
            props: {
              label: "dictValue",
              value: "dictKey"
            },
            rules: [
              {required: true, message: '请选择设备类型', trigger: 'change'}
            ],
          },
          {
            label: "设备状态",
            prop: "deviceStatus",
            type: 'select',
            overHidden: true,
            search: false,
            dicUrl: "/api/blade-system/dict-biz/dictionary?code=weidu_device_status",
            dataType: 'string',
            props: {
              label: "dictValue",
              value: "dictKey"
            },
            rules: [
              {required: true, message: '请选择设备状态', trigger: 'change'}
            ],
          },
          {
            label: '最后在线时间',
            prop: 'lastOnlineTime',
            type: 'datetime',
            format: 'yyyy-MM-dd HH:mm:ss',
            valueFormat: 'yyyy-MM-dd HH:mm:ss',
            minWidth: 120,
            addDisplay: false,
            editDisplay: false,
          },
          {
            label: '设备描述',
            prop: 'description',
            type: "textarea",
            span: 24,
            minRows: 3,
            hide: false,
            search: false, // 不参与查询
            addDisplay: false,
            editDisplay: false,
          },
          {
            label: "用户ID",
            prop: "userId",
            addDisplay: false,
            editDisplay: false,
          },
          {
            label: '备注',
            prop: 'remark',
            type: "textarea",
            span: 24,
            minRows: 3,
            hide: true,
            search: false, // 不参与查询
            addDisplay: false,
            editDisplay: false,
            rules: [
              {max: 50, message: '备注不能超过50个字符', trigger: 'blur'}
            ]
          },
          {
            label: "状态",
            prop: "status",
            type: 'select',
            overHidden: true,
            search: false,
            dicUrl: "/api/blade-system/dict-biz/dictionary?code=status_flag",
            dataType: 'string',
            addDisplay: false,
            editDisplay: false,
            props: {
              label: "dictValue",
              value: "dictKey"
            },
            rules: [
              {required: true, message: '请选择状态', trigger: 'change'}
            ],
            value: 1
          },
        ]
      },
    }
  },
  methods: {
    async handleExport() {
      this.exportLoading = true
      try {
        const params = this.formatParams(Object.assign({}, this.defaultParams, this.query))
        const res = await exportExcel(params)
        downloadXls(res.data, `位度设备信息_${Date.now()}.xlsx`)
        this.$message.success('导出成功')
      } catch (e) {
        console.warn(e)
        this.$message.error((e && e.message) || '导出失败')
      } finally {
        this.exportLoading = false
      }
    }
  }
}
</script>
<style scoped lang="scss">
</style>
